import { writable } from "svelte/store";
import { api } from "../api.js";
import { isAuthenticated } from "./auth.js";
import { get } from "svelte/store";

export const unreadCount = writable<number>(0);

let pollInterval: ReturnType<typeof setInterval> | null = null;

export async function refreshUnreadCount(): Promise<void> {
	if (!get(isAuthenticated)) return;
	try {
		const { unreadCount: count } = await api.notifications.unreadCount();
		unreadCount.set(count);
	} catch {
		// silently ignore — non-critical
	}
}

/** Start polling for unread count every 60 seconds. Call once on mount. */
export function startNotificationPolling(): () => void {
	refreshUnreadCount();
	pollInterval = setInterval(refreshUnreadCount, 60_000);
	return () => {
		if (pollInterval) {
			clearInterval(pollInterval);
			pollInterval = null;
		}
	};
}
